/**
 * ``<RequiresSuperAdmin>`` — route gate for the vendor control plane.
 * Redirects non-super-admins to the dashboard. Belt to the server-side
 * ``IsSuperAdmin`` suspenders so a deep-linked ``/admin/*`` URL can't strand
 * a normal user on a 403.
 */
import { Navigate } from "react-router-dom";

import { Skeleton } from "@/components/ui/skeleton";
import { useMe } from "@/lib/me";

export function RequiresSuperAdmin({ children }: { children: React.ReactNode }) {
  const { data, isLoading } = useMe();

  if (isLoading || !data) {
    return (
      <div className="space-y-4 p-6">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  if (!data.is_super_admin && !data.is_superuser) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
